// Per-user measurements captured once in the Share-a-Fit form and stored on
// the profile. Kept in one place so the form and the profile page stay in sync
// with the backend's accepted values (see WAIST_SIZES / SHOE_SIZES in server.py).

// Waist in inches, 26–38.
export const WAIST_SIZES = Array.from({ length: 13 }, (_, i) => String(26 + i));

// Shoe size, UK sizing, 8–13 with half sizes.
export const SHOE_SIZES = [
  "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13",
];

// Per-kind config for the "your size" dropdown in the share form.
export const SIZE_FIELD_BY_KIND = {
  clothing: {
    key: "waist_size",
    label: "Your waist (in)",
    unit: "in",
    options: WAIST_SIZES,
  },
  shoes: {
    key: "shoe_size",
    label: "Your shoe size (UK)",
    unit: "UK",
    options: SHOE_SIZES,
  },
};
